export default "__VITE_ASSET__686CaL9H__"